// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logos_wrapper__VK7o_","inner":"Logos_inner__PzDLX","logo":"Logos_logo__beFUO","headline":"Logos_headline__F_rL4"};